export enum StationDurationEnum {
  D_15_MIN = 15,
  D_30_MIN = 30,
  D_60_MIN = 60,
  D_90_MIN = 90,
}

export interface StationDurationRadioButton {
  minutes: StationDurationEnum;
  id: string;
}

export const StationDurations: StationDurationRadioButton[] = [
  {
    minutes: StationDurationEnum.D_15_MIN,
    id: '15',
  },
  {
    minutes: StationDurationEnum.D_30_MIN,
    id: '30',
  },
  {
    minutes: StationDurationEnum.D_60_MIN,
    id: '60',
  },
  {
    minutes: StationDurationEnum.D_90_MIN,
    id: '90',
  },
];
